import React from "react";
import ZTApi from "../../util/ZTApi";

class GenericPage extends React.Component{
    componentWillUnmount(){
        ZTApi.clearQueue();
    }
}

export default GenericPage;